import { render, staticRenderFns } from "./VeterinaryReproduction.vue?vue&type=template&id=bae5ed6e&scoped=true"
import script from "./VeterinaryReproduction.vue?vue&type=script&lang=js"
export * from "./VeterinaryReproduction.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryReproduction.vue?vue&type=style&index=0&id=bae5ed6e&prod&scoped=true&lang=css"
import style1 from "./VeterinaryReproduction.vue?vue&type=style&index=1&id=bae5ed6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae5ed6e",
  null
  
)

export default component.exports